/**
 * Coups de pouce — Attendu 683 « Identifier si une situation relève de la proportionnalité ».
 * Une entrée par generator_key (cf. gen_683.js).
 */

// ── Tableau prop ou non : le test de la multiplication, en tableau (id cp683play1) ──
// Exemples hors pool (billes/masse, jours/hauteur d'une plante) : rien de
// recopiable. Un tableau qui passe le test (toujours × 3) face à un tableau
// qui le rate (× 4, × 2,5, × 2). Cadence 2 s, remise à zéro au clic.
const SVG_TABLEAU_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 224" role="img"
     aria-label="Deux tableaux empilés. Billes 2, 4, 5 et masses 6, 12, 15 grammes : une flèche fois 3 sur le côté droit relie la ligne du haut à celle du bas, proportionnel. Jours 1, 2, 3 et hauteurs 4, 5, 6 centimètres : les colonnes donnent fois 4, fois 2,5, fois 2 — la flèche de droite porte un point d'interrogation, pas proportionnel">
  <g id="cp683play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- tableau A : billes -->
  <g opacity="0">
    <g stroke="#1E3A8A" stroke-width="1" fill="none">
      <rect x="15" y="44" width="185" height="44" rx="3"/>
      <line x1="15" y1="66" x2="200" y2="66"/>
      <line x1="90" y1="44" x2="90" y2="88"/><line x1="126" y1="44" x2="126" y2="88"/><line x1="162" y1="44" x2="162" y2="88"/>
    </g>
    <g font-size="11" fill="#0f172a" font-family="system-ui,sans-serif">
      <text x="20" y="59" font-weight="600">Billes</text><text x="108" y="59" text-anchor="middle">2</text><text x="144" y="59" text-anchor="middle">4</text><text x="180" y="59" text-anchor="middle">5</text>
      <text x="20" y="81" font-weight="600">Masse (g)</text><text x="108" y="81" text-anchor="middle">6</text><text x="144" y="81" text-anchor="middle">12</text><text x="180" y="81" text-anchor="middle">15</text>
    </g>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- flèche × 3 sur le côté droit du tableau A -->
  <g opacity="0">
    <path d="M206 54 Q226 66 206 80" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <path d="M206 80 L212 73 M206 80 L214 79" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="242" y="70" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+1.2s" fill="freeze"/>
  </g>
  <!-- tableau B : plante -->
  <g opacity="0">
    <g stroke="#1E3A8A" stroke-width="1" fill="none">
      <rect x="15" y="108" width="185" height="44" rx="3"/>
      <line x1="15" y1="130" x2="200" y2="130"/>
      <line x1="90" y1="108" x2="90" y2="152"/><line x1="126" y1="108" x2="126" y2="152"/><line x1="162" y1="108" x2="162" y2="152"/>
    </g>
    <g font-size="11" fill="#0f172a" font-family="system-ui,sans-serif">
      <text x="20" y="123" font-weight="600">Jours</text><text x="108" y="123" text-anchor="middle">1</text><text x="144" y="123" text-anchor="middle">2</text><text x="180" y="123" text-anchor="middle">3</text>
      <text x="20" y="145" font-weight="600">Haut. (cm)</text><text x="108" y="145" text-anchor="middle">4</text><text x="144" y="145" text-anchor="middle">5</text><text x="180" y="145" text-anchor="middle">6</text>
    </g>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+2.9s" fill="freeze"/>
  </g>
  <!-- les multiplicateurs de chaque colonne, sous le tableau B -->
  <g opacity="0" font-size="11" font-weight="700" fill="#DC2626" text-anchor="middle" font-family="system-ui,sans-serif">
    <text x="108" y="166">× 4</text><text x="144" y="166">× 2,5</text><text x="180" y="166">× 2</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+3.8s" fill="freeze"/>
  </g>
  <!-- flèche « × ? » sur le côté droit du tableau B -->
  <g opacity="0">
    <path d="M206 118 Q226 130 206 144" fill="none" stroke="#DC2626" stroke-width="1.8"/>
    <path d="M206 144 L212 137 M206 144 L214 143" fill="none" stroke="#DC2626" stroke-width="1.8"/>
    <text x="242" y="134" font-size="13" font-weight="700" fill="#DC2626" text-anchor="middle" font-family="system-ui,sans-serif">× ?</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+4.5s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="184" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="192" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Billes : toujours × 3, le tableau est proportionnel.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+2.1s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="208" width="8" height="8" rx="2" fill="#DC2626"/>
    <text x="36" y="216" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Plante : le nombre change, pas proportionnel.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play1.click+5.3s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_TABLEAU = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Cherche le nombre qui fait passer de la ligne du haut à celle du bas : il doit être **le même dans toutes les colonnes**.',
            ],
            svg: SVG_TABLEAU_ANIM,
        },
    ],
};

// ── Coefficient : trouver, vérifier, remonter (id cp683play2) ──
// Exemple hors pool (sachets/bonbons) : rien de recopiable. Les trois règles
// jouées dans l'ordre : bas ÷ haut sur une colonne, flèche × 5 valable
// partout (coches vertes), puis la flèche inverse × 0,2 pour remonter.
const SVG_COEFF_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 184" role="img"
     aria-label="Un tableau sachets 2, 5, 8 et bonbons 10, 25, 40. Sur la première colonne, 10 divisé par 2 égale 5. Une flèche fois 5 descend sur le côté droit, des coches vertes valident 25 et 40. Une flèche fois 0,2 remonte : l'inverse du coefficient redonne les nombres du haut">
  <g id="cp683play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- surlignage de la colonne 1 -->
  <rect x="90" y="44" width="36" height="44" fill="#FDE68A" opacity="0"><animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/><animate attributeName="opacity" values="0;0.6" dur="0.3s" begin="cp683play2.click+1.2s" fill="freeze"/></rect>
  <!-- tableau -->
  <g opacity="0">
    <g stroke="#1E3A8A" stroke-width="1" fill="none">
      <rect x="15" y="44" width="185" height="44" rx="3"/>
      <line x1="15" y1="66" x2="200" y2="66"/>
      <line x1="90" y1="44" x2="90" y2="88"/><line x1="126" y1="44" x2="126" y2="88"/><line x1="162" y1="44" x2="162" y2="88"/>
    </g>
    <g font-size="11" fill="#0f172a" font-family="system-ui,sans-serif">
      <text x="20" y="59" font-weight="600">Sachets</text><text x="108" y="59" text-anchor="middle">2</text><text x="144" y="59" text-anchor="middle">5</text><text x="180" y="59" text-anchor="middle">8</text>
      <text x="20" y="81" font-weight="600">Bonbons</text><text x="108" y="81" text-anchor="middle">10</text><text x="144" y="81" text-anchor="middle">25</text><text x="180" y="81" text-anchor="middle">40</text>
    </g>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+0.3s" fill="freeze"/>
  </g>
  <!-- règle 1 : bas ÷ haut sur la colonne surlignée -->
  <text x="235" y="102" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">10 ÷ 2 = 5<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+1.2s" fill="freeze"/></text>
  <!-- règle 2 : la flèche × 5 descend, coches sur les autres colonnes -->
  <g opacity="0">
    <path d="M206 54 Q226 66 206 80" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <path d="M206 80 L212 73 M206 80 L214 79" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="235" y="70" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 5</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+2.6s" fill="freeze"/>
  </g>
  <g opacity="0" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">
    <text x="144" y="102">✓</text><text x="180" y="102">✓</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+4s" fill="freeze"/>
  </g>
  <!-- règle 3 : la flèche inverse × 0,2 remonte, avec le calcul de l'inverse -->
  <g opacity="0">
    <path d="M300 80 Q320 66 300 52" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <path d="M300 52 L306 59 M300 52 L308 53" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <text x="330" y="70" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">× 0,2</text>
    <text x="315" y="102" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">1 ÷ 5 = 0,2</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+5.4s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="128" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="136" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Le coefficient est 5, le même pour toutes les colonnes.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+4.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="152" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="160" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Pour remonter, on multiplie par l'inverse 0,2.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp683play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp683play2.click+6.2s" fill="freeze"/>
  </g>
</svg>`.trim();

// Animation seule (décision utilisateur 2026-08-10) : les règles écrites sont
// retirées, l'animation joue les trois gestes.
const CP_COEFFICIENT = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_COEFF_ANIM,
        },
    ],
};

const CP_683 = {
    tableau_prop_qcm: CP_TABLEAU,
    // Partages (décisions utilisateur 2026-08-10) : même test mental face à
    // une situation narrative ou aux affirmations du V/F.
    situation_qcm: CP_TABLEAU,
    proprietes_vf: CP_TABLEAU,
    classer_situations: CP_TABLEAU,
    contre_exemple_qcm: CP_TABLEAU,
    coefficient_saisie: CP_COEFFICIENT,
};

export default CP_683;
